import { apiEndpoint, baseUrl, chicksGroupBaseUrl, clientId, debug } from '../../environment';
import { ChicksGroupAuth } from '@chicksgroup/auth';
import { inject } from 'aurelia';
import { TokenService } from '../../services/token-service';
import notifications from '../notifications-manager';

export const AuthClient = new ChicksGroupAuth({
    baseUrl: baseUrl()!,
    baseApiURL: apiEndpoint()!,
    clientId: clientId()!,
    ssoUrl: chicksGroupBaseUrl(),
    localLoginEnabled: debug()
});

@inject(
    TokenService
)
export class AuthenticationHandler {
    protected tokenService: TokenService;

    constructor(
        tokenService: TokenService
    ) {
        this.tokenService = tokenService;
    }

    async handleSSORedirection() {
        try {
            const accessTokenResponse = await AuthClient.exchangeSSOAuthCode();

            if (!accessTokenResponse.token) {
                if (accessTokenResponse.error === 'NONCE_MISMATCH') {
                    notifications.toast('Failed to validate sign in request. Please try again.').show();
                }

                return;
            }

            this.tokenService.saveToken(accessTokenResponse.token);
        } catch (e) {
            console.log(e);
        } finally {
            if (AuthClient.handledRedirection) {
                window.location.href = window.location.href.split('#')[0];
            }

            AuthClient.clear();
        }
    }

    async redirectToSSO(opts: Parameters<ChicksGroupAuth['redirectToSSO']>[0]) {
        const authToken = await AuthClient.redirectToSSO(opts);

        if (authToken) {
            this.tokenService.saveToken(authToken);
            window.location.reload();
        }
    }
}
